import React, { Component } from "react";
import { Link } from "@sitecore-jss/sitecore-jss-react";
import Icon from "../../elements/icon";
import { gtag } from "../../utils";
import "./style.scss";

export default class SocialMedia extends Component {
  render() {
    if (!this.props.fields) return null;
    let { fields, rendering } = this.props,
      { socialItems, nofollowTextlink } = fields;
    const gtgaClick = (e, item) => {
      gtag('event', 'footer_clk', {
        'footer_name': item?.fields?.link?.value?.href,
      });
    }
    if (socialItems != null && socialItems.length > 0) {
      return (
        <div className={"socialMedia"} datasourceid={rendering && rendering.dataSource}>
          {socialItems.map((item, index) => {
            return (
              <Link key={index} field={item.fields.link} rel={nofollowTextlink && nofollowTextlink.value ? "nofollow" : ""} onClick={(e) => gtgaClick(e, item)}>
                {item.fields.iconName && <Icon icon={{ ...item.fields.iconName.value }} />}
              </Link>
            );
          })}
        </div>
      );
    }
  }
}
